// extracted by mini-css-extract-plugin
module.exports = {"Label":"Checkbox_Label_2ZZNj","Checkbox":"Checkbox_Checkbox_23JXs"};